module.exports = __webpack_public_path__ + "img/chevron-left-small-white.ad7ad05e.svg";